exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-item[data-v-392132b6]{display:flex;flex-direction:row;color:#273239;padding:0 12vw 0 8vw}.text-size[data-v-392132b6]{font-size:14px}.quantity[data-v-392132b6]{width:10%;line-height:20px;font-size:14px;color:#273239}.name[data-v-392132b6]{display:flex;flex-direction:column;flex:4 1 0%}.price[data-v-392132b6]{flex:1 1 0%;text-align:right;font-size:15px;line-height:20px}.name-label[data-v-392132b6]{font-size:16px;line-height:22px;font-weight:700;padding-bottom:4px;color:#273239}.price-label[data-v-392132b6]{color:#273239;width:100%;height:20px;font-size:15px;font-weight:700;font-style:normal;font-stretch:normal;line-height:1.33;letter-spacing:normal;text-align:right;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-392132b6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/CheckoutOptionItem.vue
// module id = 436
// module chunks = 0